<template>
  <div class="doc">
    <div class="item">
      <img class="img" src="@/assets/activity/picture_VIP01.png" alt="">
    </div>
    <div class="item">
      <img class="img" src="@/assets/activity/picture_VIP02.png" alt="">
      <router-link to="/vipV3/index?headShow=0" class="btn-first"></router-link>
    </div>
    <div class="item">
      <img class="img" src="@/assets/activity/picture_VIP03.png" alt="">
      <router-link to="/examThreeVideo/index?headShow=0" class="btn-second"></router-link>
    </div>
  </div>
</template>

<script>
export default {
    name: 'doubleEleven'
}
</script>

<style scoped lang="scss">
  .doc{
    line-height: 1;
    font-size: 0;
    .item{
      position: relative;
    }
    .img{
      width: 375px;
    }

    .btn-first{
      position: absolute;
      bottom: 40px;
      height: 55px;
      width: 210px;
      left: 50%;
      transform: translateX(-50%);
    }

    .btn-second{
      position: absolute;
      bottom: 50px;
      height: 55px;
      width: 210px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

</style>
